// DEPLOY: /var/www/woody.wtf/frontend/src/pages/ApproveIp.js
// Landing page for the "approve a login from a new location" email (account lockdown / strict
// known-IPs mode, backend/security.py): redeems the token, then points to the login page.
import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../api';
import AuthLayout from '../components/AuthLayout';
import Alert from '../components/Alert';

export default function ApproveIp() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [state, setState] = useState({ done: false, ok: false, message: '' });

  useEffect(() => {
    if (!token) { setState({ done: true, ok: false, message: 'No token in the link' }); return; }
    api.post('/security/approve-ip', { token })
      .then(r => setState({ done: true, ok: true, message: r.data.message }))
      .catch(e => setState({ done: true, ok: false, message: e.response?.data?.error || 'Could not approve the address' }));
  }, [token]);

  if (!state.done) return <AuthLayout title="Approving..."><p style={{ color: 'var(--text-muted)', fontSize: '14px' }}>One moment.</p></AuthLayout>;
  return (
    <AuthLayout title={state.ok ? 'Address approved' : 'Not approved'}>
      <Alert type={state.ok ? 'success' : 'error'}>{state.message}</Alert>
      <p style={{ fontSize: '13px' }}><Link to="/login" style={{ color: 'var(--accent)' }}>Go to the login page</Link></p>
    </AuthLayout>
  );
}
